import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OfferTypesEnum } from './pricing-data.data';
import { Observable } from 'rxjs';
import { getOfferByType } from './pricing-data.reducer';
import { PricingOffer } from './models/pricing-offer.model';

@Injectable()
export class PricingDataStore {
  constructor(private _store: Store<any>) {}

  getOfferByType(
    offerType: OfferTypesEnum
  ): Observable<PricingOffer | boolean> {
    return this._store.select(getOfferByType(offerType));
  }
}
